import { useMemo } from 'react';

import { mapReadingRefsToSubscriptionIdentifiers } from '@/features/equipment-browser/subscriptions/map-to-subscription-identifiers';
import type { SubscriptionIdentifier } from '@/hooks/query-hooks/gaia-api/use-subscription-base';

import { useAllCompressorAlarmRefs } from './use-compressor-alarm-refs';

/**
 * The Alarm Code points of every device (or of `deviceIds` only) to stream, for
 * `useCompressorAlarm` to read. Callers add them to the readings subscription they
 * already have, never a second one: every stream hook handles every websocket
 * message, so each extra one on a page adds that whole cost again.
 */
export const useCompressorAlarmSubscriptionIds = (
  deviceIds?: string[]
): SubscriptionIdentifier[] => {
  const refs = useAllCompressorAlarmRefs(deviceIds);

  return useMemo(
    () => mapReadingRefsToSubscriptionIdentifiers(refs.flatMap((device) => Object.values(device))),
    [refs]
  );
};
